import React from 'react'
import PropTypes from 'prop-types'
import { propType } from 'graphql-anywhere'
import ReactSVG from 'react-svg'

import { DeepLink } from '../../../hoc/deep-link'
import CONTENT_ITEM_FRAGMENT from '../../../../graphql/fragments/content-item.gql'
import trailerIcon from '../../../../images/trailer.svg'
import Button from '../../button'
import styles from './view-trailer-button.css'

const ViewTrailerButton = ({
  contentItem,
  trailerUrl,
  onClick
}) => {
  return (
    <DeepLink
      onClick={onClick}
      to={trailerUrl}
      className={styles.viewTrailerButtonFrame}
    >
      <Button
        className={styles.viewTrailerButton}
        isRental={contentItem.isRental}
        darkBGSecondary
      >
        <ReactSVG
          src={trailerIcon}
          beforeInjection={(svg) => {
            svg.setAttribute('class', styles.trailerIcon)
          }}
        />
      </Button>

      <span className={styles.cta}>
        Trailer
      </span>
    </DeepLink>
  )
}

ViewTrailerButton.propTypes = {
  trailerUrl: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  contentItem: propType(CONTENT_ITEM_FRAGMENT).isRequired
}

export default ViewTrailerButton
